import { apiHelpers } from '@/services/api';

// Dashboard types matching backend
export interface DashboardStats {
  upcomingEventsCount: number;
  pendingExpensesCount: number;
  pendingExpensesTotal: number;
  unreadNotificationsCount: number;
  activeGameSessionsCount: number;
  totalAchievements: number;
  userLevel: number;
  userXp: number;
}

export interface ActivityItem {
  id: string;
  type: 'event' | 'expense' | 'gift' | 'game' | 'achievement';
  title: string;
  description: string;
  timestamp: Date | string;
  metadata?: Record<string, unknown>;
}

export interface UpcomingEvent {
  id: string;
  title: string;
  description: string | null;
  startTime: Date | string;
  endTime: Date | string;
  location: string | null;
  category: string;
  participantStatus: string | null;
  participantCount: number;
  creator: {
    id: string;
    displayName: string | null;
    avatarUrl: string | null;
  };
}

export interface UpcomingBirthday {
  userId: string;
  username: string;
  displayName: string | null;
  avatarUrl: string | null;
  birthday: Date | string;
  daysUntil: number;
}

export interface QuickStats {
  eventsThisMonth: number;
  gamesPlayedThisMonth: number;
  expensesPaidThisMonth: number;
  achievementsEarnedThisMonth: number;
}

// Dashboard Service
export const dashboardService = {
  /**
   * Get main dashboard statistics
   */
  async getStats(): Promise<DashboardStats> {
    return apiHelpers.get<DashboardStats>('/dashboard/stats');
  },

  /**
   * Get recent activity feed
   */
  async getActivity(limit = 10): Promise<ActivityItem[]> {
    return apiHelpers.get<ActivityItem[]>('/dashboard/activity', { limit });
  },

  /**
   * Get upcoming events
   */
  async getUpcomingEvents(limit = 5): Promise<UpcomingEvent[]> {
    return apiHelpers.get<UpcomingEvent[]>('/dashboard/upcoming-events', { limit });
  },

  /**
   * Get upcoming birthdays
   */
  async getUpcomingBirthdays(limit = 5): Promise<UpcomingBirthday[]> {
    return apiHelpers.get<UpcomingBirthday[]>('/dashboard/upcoming-birthdays', { limit });
  },

  /**
   * Get quick stats for the current month
   */
  async getQuickStats(): Promise<QuickStats> {
    return apiHelpers.get<QuickStats>('/dashboard/quick-stats');
  },
};

export default dashboardService;
